import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Info, ArrowRight } from 'lucide-react';

const NotFound = () => {
  const [inputId, setInputId] = useState('');
  const navigate = useNavigate();

  const extractId = (value) => {
    const trimmed = value.trim();
    // URLが貼り付けられた場合、/#/ 以降のIDを抽出
    const match = trimmed.match(/#\/([a-zA-Z0-9-]+)/);
    if (match) return match[1];
    // そのままIDとして扱う
    return trimmed;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const id = extractId(inputId);
    if (id) {
      navigate(`/${id}`);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-[800px]">
        <img
          className="mx-auto h-12 w-auto"
          src={`${process.env.PUBLIC_URL}/images/Brains_logo.png`}
          alt="Brains Logo"
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 tracking-tight">
          ファイルダウンロード
        </h2>
        <div className="mt-2 flex justify-center gap-8">
          <div className="text-center">
            <p className="text-sm text-gray-500">企業内全文検索エンジン</p>
            <p className="text-2xl font-bold text-[#5a79ba]">Neuron ES</p>
          </div>
          <div className="text-center">
            <p className="text-sm text-gray-500">AI異常検知ソリューション</p>
            <p className="text-2xl font-bold text-[#5a79ba]">Impulse</p>
          </div>
        </div>
      </div>

      <div className="mt-8 mx-auto w-full max-w-[800px]">
        <div className="bg-white py-8 px-4 shadow-sm border border-gray-200/60 rounded-2xl sm:px-10">
          <div className="flex flex-col items-center text-center mb-6">
            <Info className="h-14 w-14 text-[#5a79ba] mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              ダウンロードIDが必要です
            </h3>
            <p className="text-sm text-gray-500">
              URLにダウンロードIDが含まれていません。<br />
              以下の入力欄にIDを入力してください。
            </p>
          </div>

          {/* ID入力フォーム */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="download-id" className="block text-sm font-semibold text-gray-700 mb-1.5">
                ダウンロードID
              </label>
              <input
                type="text"
                id="download-id"
                value={inputId}
                onChange={(e) => setInputId(e.target.value)}
                placeholder="例: a1b2c3d4-e5f6-7890-abcd-ef1234567890"
                className="block w-full px-3.5 py-2.5 border border-gray-200 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#5a79ba]/30 focus:border-[#5a79ba] sm:text-sm transition-all duration-200"
              />
            </div>
            <button
              type="submit"
              disabled={!inputId.trim()}
              className="w-full flex items-center justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-semibold text-white bg-[#5a79ba] hover:bg-[#46639e] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5a79ba] disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 hover:shadow-md"
            >
              ダウンロードページを表示
              <ArrowRight className="h-4 w-4 ml-2" />
            </button>
          </form>

          {/* 案内セクション */}
          <div className="mt-6 pt-6 border-t border-gray-100">
            <p className="text-xs font-semibold text-gray-600 mb-3">ダウンロードIDの確認方法</p>
            <div className="bg-slate-50 rounded-xl p-4 text-xs text-gray-600 space-y-2">
              <p>共有されたURLの末尾にある文字列がダウンロードIDです。</p>
              <div className="bg-white rounded-lg px-3 py-2 font-mono text-[11px] border border-gray-200 break-all">
                <span className="text-gray-500">https://downloads.neuron.brains-tech.co.jp/#/</span>
                <span className="text-[#5a79ba] font-bold underline decoration-[#5a79ba]/30 underline-offset-2">a1b2c3d4-e5f6-...</span>
              </div>
              <p className="text-gray-500">
                上記の<span className="text-[#5a79ba] font-semibold">青色の部分</span>がダウンロードIDです。<br />
                URL全体を貼り付けてもIDが自動で読み取られます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
